<template>
    <span>
        <i class="fa fa-fax fa-lg"
           aria-hidden="false"
           :title="uLang('app.book_invoice')"
           @click="bookInvoice"
        ></i>
        <portal to="modals" v-if="showModal">
            <b-modal
                v-model="showModal"
                :hideFooter="true"
                :title="uLang('app.confirm_book_invoice', { entity: lang('app.buy_invoice') })"
                size="lg"
                :closeOnEsc="false"
                :closeOnBackdrop="false"
            >
                <buy-invoice-form
                    :invoiceId="invoiceId"
                    @close="showModal = false"
                    @invoiceBooked="handleInvoiceBooked"
                ></buy-invoice-form>
            </b-modal>
        </portal>
    </span>
</template>

<script>
    import BookInvoiceButton from './book-invoice-button'
    import { BuyInvoiceForm } from '~/components/forms'
    import { ConfirmationAlert } from '~/Swals'

    export default {
        name: 'BookBuyInvoiceButton',
        extends: BookInvoiceButton,
        props: {
            type: {
                Type: String,
                default: 'buy'
            }
        },

        components: {
            BuyInvoiceForm,
        },

        data() {
            return {
                'invoiceNumber': null,
                'invoiceDate': null,
                'showModal': false,
            }
        },

        methods: {
            bookInvoice() {
                new ConfirmationAlert({
                    text: this.uLang('app.confirm_book_invoice', { entity: this.lang(this.invoiceType) }),
                }).show().then(() => {
                    this.showModal = true;
                })
            },

            handleInvoiceBooked(data) {
                if (data.message === 'success') {
                    this.$snotify.info(uLang('app.successfully_booked_invoice', {entity: this.uLang(this.invoiceType)}));
                    vue.$emit('reloadTable');
                    return;
                } else if (data.message === 'error') {
                    this.$snotify.error(uLang('app.error_booked_invoice', { entity: this.lang(this.invoiceType) }));
                } else {
                    this.$snotify.error(data.message);
                }
            }
        }
    }
</script>

<style>

</style>